// Types
import type { SubscriptionTypeT } from "@/@types/subscription";

export const EXCLUDED_PLAN_IDS = ["BWP3", "BWP14"];

export const SUBSCRIPTION_TYPES: SubscriptionTypeT[] = [
  { id: "BWP0", name: "Plano Business" },
  {
    id: "BWP1",
    name: "Plano Premium",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/9d024a32-7302-4563-a003-a72efb95c5b1",
      monthly: "https://pay.baseworks.com.br/subscribe/9d024558-f652-4403-8264-c07fc1444d8a",
      biannual: "https://pay.baseworks.com.br/subscribe/9d025b0d-9d04-4c0f-8eee-8cec83b14907",
      quarterly: "https://pay.baseworks.com.br/subscribe/9d025c60-e9ef-41c1-906b-c7a058e835e2"
    }
  },
  {
    id: "BWP2",
    name: "Plano Plus",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/9cfad20e-416d-4205-92ab-65d54e1792c0",
      monthly: "https://pay.baseworks.com.br/subscribe/9d0241bb-96b7-4e25-8cca-01f605d11ec7",
      biannual: "https://pay.baseworks.com.br/subscribe/9d1a9941-8023-4840-96b3-730605640e46",
      quarterly: "https://pay.baseworks.com.br/subscribe/9cfacd78-f67e-4b61-88f8-1756f867254f"
    }
  },
  { id: "BWP3", name: "Plano Máquina de Leads" },
  {
    id: "BWP4",
    name: "Plano Lite",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/9d049fd1-639e-4bc2-a73e-227bda9ce8d1",
      monthly: "https://pay.baseworks.com.br/subscribe/9cfacb6f-1128-4bac-92ac-9d1faa1b0cb6",
      biannual: "https://pay.baseworks.com.br/subscribe/9d049ff0-3238-4f9f-81c9-24f1dcf31b41",
      quarterly: "https://pay.baseworks.com.br/subscribe/9d04a004-5a2c-4995-98de-8d5c876090a0"
    }
  },
  {
    id: "BWP5",
    name: "Plano Básico",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/plano-basico-mensal-cb01",
      monthly: "https://pay.baseworks.com.br/subscribe/plano-basico-mensal-cb01"
    }
  },
  {
    id: "BWP6",
    name: "Plano Profissional",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/plano-profissional-anual-2-meses-gratis-cb02",
      monthly: "https://pay.baseworks.com.br/subscribe/plano-profissional-mensal-cb01"
    }
  },
  {
    id: "BWP7",
    name: "Plano Escala/Individual",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/plano-escala-anual-2-meses-gratis-cb02",
      monthly: "https://pay.baseworks.com.br/subscribe/9b31eac2-95bb-4835-8dcd-45045a6f3f67"
    }
  },
  {
    id: "BWP8",
    name: "Plano Business 1",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/plano-business-1-5-anual-2-meses-gratis-cb02-b2b01",
      monthly: "https://pay.baseworks.com.br/subscribe/plano-business-1-5-mensal-cb02-b2b01"
    }
  },
  {
    id: "BWP9",
    name: "Plano Business 2",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/plano-business-2-10-anual-2-meses-gratis-cb02-b2b02",
      monthly: "https://pay.baseworks.com.br/subscribe/plano-business-2-10-mensal-cb02-b2b02"
    }
  },
  {
    id: "BWP10",
    name: "Plano Business 3",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/plano-business-3-15-anual-2-meses-gratis-cb02-b2b03",
      monthly: "https://pay.baseworks.com.br/subscribe/plano-business-3-15-mensal-cb02-b2b03"
    }
  },
  {
    id: "BWP11",
    name: "Plano Business 4",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/plano-business-4-20-anual-2-meses-gratis-cb02-b2b04",
      monthly: "https://pay.baseworks.com.br/subscribe/plano-business-4-20-mensal-cb02-b2b04"
    }
  },
  { id: "BWP12", name: "Plano Business 5" },
  { id: "BWP13", name: "Plano Trial" },
  { id: "BWP14", name: "Plano Meetbase" },
  {
    id: "BWP15",
    name: "Plano Premium Trial",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/9d024a32-7302-4563-a003-a72efb95c5b1",
      monthly: "https://pay.baseworks.com.br/subscribe/9d024558-f652-4403-8264-c07fc1444d8a",
      biannual: "https://pay.baseworks.com.br/subscribe/9d025b0d-9d04-4c0f-8eee-8cec83b14907",
      quarterly: "https://pay.baseworks.com.br/subscribe/9d025c60-e9ef-41c1-906b-c7a058e835e2"
    }
  },
  {
    id: "BWP16",
    name: "Plano Plus Trial",
    checkout: {
      annual: "https://pay.baseworks.com.br/subscribe/9cfad20e-416d-4205-92ab-65d54e1792c0",
      monthly: "https://pay.baseworks.com.br/subscribe/9d0241bb-96b7-4e25-8cca-01f605d11ec7",
      biannual: "https://pay.baseworks.com.br/subscribe/9d1a9941-8023-4840-96b3-730605640e46",
      quarterly: "https://pay.baseworks.com.br/subscribe/9cfacd78-f67e-4b61-88f8-1756f867254f"
    }
  }
];
